import React from "react";

export const wait = (time: number) =>
  new Promise((resolve) => setTimeout(resolve, time));

export const formatWithComponents = (
  text: string,
  data: Record<string, React.ReactNode>,
  renderText: (text: string) => React.ReactNode,
): React.ReactNode[] => {
  try {
    const result: React.ReactNode[] = [];
    const placeholderRegex = /\{(\w+)\}/g;

    let lastIndex = 0;
    let match: RegExpExecArray | null;
    let index = 0;

    while ((match = placeholderRegex.exec(text)) !== null) {
      // Add text before the placeholder
      if (match.index > lastIndex) {
        const textBefore = text.slice(lastIndex, match.index);
        const element = renderText(textBefore);
        result.push(
          React.isValidElement(element) ? (
            React.cloneElement(element, { key: `text-${index++}` })
          ) : (
            <React.Fragment key={`text-${index++}`}>{element}</React.Fragment>
          ),
        );
      }

      // Add the replacement element for the placeholder
      const placeholderName = match[1];
      if (placeholderName in data) {
        const element = data[placeholderName];
        result.push(
          React.isValidElement(element) ? (
            React.cloneElement(element, {
              key: `placeholder-${placeholderName}-${index++}`,
            })
          ) : (
            <React.Fragment key={`placeholder-${placeholderName}-${index++}`}>
              {element}
            </React.Fragment>
          ),
        );
      } else {
        // Keep original placeholder if no replacement found
        const element = renderText(match[0]);
        result.push(
          React.isValidElement(element) ? (
            React.cloneElement(element, { key: `text-${index++}` })
          ) : (
            <React.Fragment key={`text-${index++}`}>{element}</React.Fragment>
          ),
        );
      }

      lastIndex = match.index + match[0].length;
    }

    // Add any remaining text after the last placeholder
    if (lastIndex < text.length) {
      const element = renderText(text.slice(lastIndex));
      result.push(
        React.isValidElement(element) ? (
          React.cloneElement(element, { key: `text-${index++}` })
        ) : (
          <React.Fragment key={`text-${index++}`}>{element}</React.Fragment>
        ),
      );
    }

    return result;
  } catch (err) {
    console.error(err);

    return [<React.Fragment key="error">--</React.Fragment>];
  }
};
